module.exports = __webpack_public_path__ + "badge-challenge.svg?e3eaae9143106b58d63c9ac61829750f";


//////////////////
// WEBPACK FOOTER
// ./public/images/site/badge-challenge.svg
// module id = 478
// module chunks = 0